//#region react
import React, { useEffect, useState } from 'react';
//bootstrap
import { Col, Row, Button } from 'react-bootstrap';

// redux
import { useSelector } from 'react-redux';
import { selectSelectedTaskToView } from "_redux/slices/timeline/selected-task";
import { selectIata, selectUserDb } from "_redux/slices/main-screen/user";
import { selectFlightListIndexed } from '_redux/slices/timeline/flight-information-list';

// styles 
import { Spacing } from '_styles'

// tremor
import { Subtitle } from "@tremor/react";

// functions 
import { getAssistanceString, handleNotesText, processName } from '_utils/functions';
import { TfiViewList } from "react-icons/tfi";
//component
import PaxJourney from './pax-journey';

//#endregion

const RowValue = ({ title, value }) => {
    return (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: Spacing.SCALE_12, flex: 1 }}>
            <div style={{ flex: 1 }}>
                <Subtitle>{title}</Subtitle>
                <p>{value}</p>
            </div>
        </div>
    )
};

const GroupedPax = ({ paxArray, notes, arrOrDep }) => {
    const [selectedPax, setSelectedPax] = useState(null);
    return (
        <Row className="gap-2">
            {paxArray?.map((pax, index) => (
                <Col xs={12} md={4} lg={4} key={index}>
                    <Button
                        onClick={() => setSelectedPax(pax)}
                        variant={selectedPax === pax ? "outline-primary" : "outline-secondary"}
                        style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", borderRadius: "13px", fontSize: "12px", paddingBlock: "5px", cursor: "pointer" }}
                    >
                        {processName(pax?.name) ?? ""}
                        <TfiViewList size={15} />
                    </Button>
                </Col>
            ))}

            {!Object.isObjectEmpty(selectedPax) && (
                <>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", rowGap: Spacing.SCALE_12, columnGap: Spacing.SCALE_48, marginTop: Spacing.SCALE_16 }}>
                        <RowValue title="Name" value={processName(selectedPax?.name) ?? ""} />
                        <RowValue title="Assistance" value={getAssistanceString(selectedPax?.assistance) ?? ""} />
                        {Array.isFullArray(notes) ? notes?.map(note => <RowValue title="Notes" value={note?.text ?? "N/A"} />) :
                            <RowValue title="Notes" value={notes} />
                        }
                        <RowValue title="SITA Notes" value={selectedPax?.assistance} />
                    </div>
                    <PaxJourney bookingId={selectedPax.originalBookingId || selectedPax._id} type={arrOrDep} />
                </>
            )}
        </Row>
    );
};

const getDurationTime = (startTime, completedTime) => {
    if (!startTime || !completedTime) return "Not completed";
    const seconds = startTime.seconds ?? startTime._seconds, nanoseconds = startTime.nanoseconds ?? startTime._nanoseconds;
    const startMillis = seconds * 1000 + nanoseconds / 1_000_000;
    const completedMillis = completedTime.seconds * 1000 + completedTime.nanoseconds / 1_000_000;

    const durationMs = completedMillis - startMillis;

    if (durationMs < 0) return "Invalid Time Range";

    const minutes = Math.ceil(durationMs / 60000);
    return `${minutes} min${minutes > 1 ? 's' : ''}`;
};


const getStartTime = (startTime) => {
    const seconds = startTime.seconds ?? startTime._seconds, nanoseconds = startTime.nanoseconds ?? startTime._nanoseconds;
    const timestampMs = seconds * 1000 + nanoseconds / 1_000_000;

    // Create a JavaScript Date object
    const date = new Date(timestampMs);

    // Format to readable string (local time)
    const readable = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    return readable

}

const ViewJob = () => {

    //#region redux
    const taskToView = useSelector(selectSelectedTaskToView);
    const userDb = useSelector(selectUserDb);
    const flightList = useSelector(selectFlightListIndexed);
    const iata = useSelector(selectIata);
    //#endregion

    //#region local states
    const [flightNumber, setFlightNumber] = useState("");
    const [departure, setDeparture] = useState("");
    const [arrival, setArrival] = useState("");
    const [departureTime, setDepartureTime] = useState("");
    const [arrivalTime, setArrivalTime] = useState("");
    const [passenger, setPassenger] = useState("");
    const [assistance, setAssistance] = useState("WCHR");
    const [terminal, setTerminal] = useState("");
    const [gate, setGate] = useState("");
    const [stand, setStand] = useState("N/A");
    const [bookingNotes, setBookingNotes] = useState("");
    const [sitaNotes, setSitaNotes] = useState("");
    const [taskDuration, setTaskDuration] = useState("Not completed")
    const [taskStartTime, setTaskStartTime] = useState("Not Started")
    const [codeShare, setCodeShare] = useState(null)
    const [checkInTime, setCheckInTime] = useState(null);
    const [arrOrDep, setArrOrDep] = useState("A")

    //#endregion

    //#region useEffect

    // Get departure & arrival time
    useEffect(() => {
        let tempDepartureDate = "", tempArrivalDate = "";
        if (flightNumber) {
            let tempNumber = flightNumber.includes('EZY') ? flightNumber.replace('EZY', 'U2') : flightNumber;
            let origin = "";
            let destination = "";
            if (taskToView?.flightConfirmationDetails) {
                origin = taskToView?.flightConfirmationDetails?.origin;
                destination = taskToView?.flightConfirmationDetails?.destination;
            } else if (taskToView?.flightInformation) {
                origin = taskToView?.flightInformation?.departureAirport;
                destination = taskToView?.flightInformation?.arrivalAirport;
            }
            const flightDocument = flightList[`${tempNumber}_${origin}_${destination}`];


            if (flightDocument?.type === "departure") {
                tempDepartureDate = flightDocument.operationInfo?.time
            } else {
                tempDepartureDate = ""
            }
            if (flightDocument?.type === "arrival") {
                tempArrivalDate = flightDocument.operationInfo?.time
            } else {
                tempArrivalDate = ""
            }
        }
        if (taskToView?.flightConfirmationDetails) {

            setDepartureTime(getTimeString(tempDepartureDate ? tempDepartureDate : taskToView?.flightConfirmationDetails?.departureTime));
            setArrivalTime(getTimeString(tempArrivalDate ? tempArrivalDate : taskToView?.flightConfirmationDetails?.arrivalTime));

        }
        if (taskToView?.flightInformation?.departureTime) {
            setDepartureTime(getTimeString(tempDepartureDate ? tempDepartureDate : taskToView?.flightInformation?.departureTime));
        }
        if (taskToView?.flightInformation?.arrivalTime) {
            setArrivalTime(getTimeString(tempArrivalDate ? tempArrivalDate : taskToView?.flightInformation?.arrivalTime));
        }
        if (taskToView?.completed) {
            const duration = getDurationTime(taskToView?.startTime, taskToView?.completeTime);
            setTaskDuration(duration)
        }
        if (taskToView?.startTime) {
            const startTime = getStartTime(taskToView?.startTime)
            setTaskStartTime(startTime)
        }
        if (taskToView.flightConfirmationDetails) {
            if (iata === taskToView.flightConfirmationDetails.origin) { setArrOrDep("D") } else setArrOrDep("A")
        }
        if (taskToView.flightInformation) {
            if (iata === taskToView.flightInformation.departureAirport) { setArrOrDep("D") } else setArrOrDep("A")
        }

    }, [taskToView, flightNumber]);

    // Set flight and passenger info
    useEffect(() => {
        if (!taskToView?.assignedTime) {
            if (taskToView?.combinedBooking || taskToView?.combinedRampBooking) {
                setFlightNumber(taskToView?.flightNum);
            } else {
                setFlightNumber(taskToView?.flightConfirmationDetails?.carrierCode + taskToView?.flightConfirmationDetails?.flightNumber);
            }
            setDeparture(taskToView?.flightConfirmationDetails?.origin);
            setArrival(taskToView?.flightConfirmationDetails?.destination);
            if (taskToView?.codeShareDetails?.carrierCode && taskToView?.codeShareDetails?.flightNumber) setCodeShare(taskToView.codeShareDetails.carrierCode + taskToView.codeShareDetails.flightNumber)
            setPassenger(processName(taskToView?.name ?? ""));
            setAssistance(getAssistanceString(taskToView?.assistance ?? ""));
            setBookingNotes(taskToView?.notes ?? "N/A");
            if (taskToView?.paxPositionHistory) {
                const checkinTime = taskToView.paxPositionHistory?.find(action => action.activity === "Checked-in")?.time
                setCheckInTime(getTimeString(checkinTime))
            }
            if (taskToView.paxPositionInfo?.activity === "Checked-in") {
                setCheckInTime(getTimeString(taskToView.paxPositionInfo.time))

            }
            if (taskToView?.isALTPickUp && taskToView?.taskNotes) {
                setBookingNotes(taskToView?.taskNotes);
            }


        } else {
            setFlightNumber(taskToView?.flightInformation?.flightNumber);
            setDeparture(taskToView?.flightInformation?.departureAirport);
            setArrival(taskToView?.flightInformation?.arrivalAirport);
            setPassenger(taskToView?.passengerInformation?.title ?? "");
            setAssistance(getAssistanceString(taskToView?.passengerInformation?.assistance ?? ""));
            // if (taskToView.codeShareDetails && Object.keys(taskToView.codeShareDetails).length) setCodeShare(taskToView.codeShareDetails.carrierCode + taskToView.codeShareDetails.flightNumber)

            if (taskToView?.flightBooking) {
                if (taskToView?.originalBookingDoc?.notes) setBookingNotes(taskToView?.originalBookingDoc?.notes);
                if (taskToView?.notes) setBookingNotes(taskToView.notes)
            } else {
                if (taskToView?.notes) setBookingNotes(taskToView?.notes ?? "N/A");
                if (taskToView?.taskNotes) setBookingNotes(taskToView?.taskNotes ?? "N/A");
            }
            if (taskToView?.isALTPickUp && taskToView?.taskNotes) {
                setBookingNotes(taskToView?.taskNotes);
            }
        }
    }, [taskToView, userDb]);

    // get sita notes & gate,stand,terminal
    useEffect(() => {
        if (taskToView && flightList && flightNumber && Object.keys(flightList).length > 0) {
            let tempNumber = flightNumber.includes('EZY') ? flightNumber.replace('EZY', 'U2') : flightNumber;

            let origin = "";
            let destination = "";
            if (taskToView?.flightConfirmationDetails) {
                origin = taskToView?.flightConfirmationDetails?.origin;
                destination = taskToView?.flightConfirmationDetails?.destination;
            } else if (taskToView?.flightInformation) {
                origin = taskToView?.flightInformation?.departureAirport;
                destination = taskToView?.flightInformation?.arrivalAirport;

            }

            const flightDocument = flightList[`${tempNumber}_${origin}_${destination}`];

            if (flightDocument) {
                setGate(flightDocument.gate ?? "N/A");
                setTerminal(flightDocument.terminal ?? "N/A");
                setStand(flightDocument.stand && (flightDocument.stand != "" || flightDocument.stand != "N/A") ? flightDocument.stand : "N/A");
                // setFlightStartTime(flightDocument.startTime ? getTimeString(flightDocument.startTime) : "N/A")
                // setFlightCompleteTime(flightDocument.completedTime ? getTimeString(flightDocument.completedTime) : "N/A")
            }

            if (taskToView.passengerInformation?.assistance) {
                setSitaNotes(taskToView.passengerInformation.assistance);
            } else if (taskToView.assistance) {
                setSitaNotes(taskToView.assistance);
            }
        }
    }, [taskToView, flightList, flightNumber]);

    //#endregion

    //#region functions
    // style time to string
    const getTimeString = (dateString) => {
        const dateObj = new Date(dateString);
        const options = { hour: "2-digit", minute: "2-digit", hour12: false };
        return dateObj.toLocaleString("en-US", options);
    };



    //#endregion

    return (
        <div style={{ marginBottom: Spacing.SCALE_16 }}>

            {/* Flight Information */}
            <div style={{ marginBottom: Spacing.SCALE_24 }}>
                <Subtitle>Flight Information</Subtitle>
                <hr />
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        rowGap: Spacing.SCALE_12,
                        columnGap: Spacing.SCALE_48,
                        marginTop: Spacing.SCALE_16,
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <RowValue title="Flight Number" value={flightNumber} />
                    <RowValue title="Departure" value={departure} />
                    <RowValue title="Arrival" value={arrival} />
                    <RowValue title={codeShare ? "Code Share" : ""} value={codeShare ?? ""} />

                    <RowValue title="Departure Time" value={departureTime} />
                    <RowValue title="Arrival Time" value={arrivalTime} />
                    <RowValue title={""} value={""} />
                    <RowValue title={""} value={""} />

                    <RowValue title="Terminal" value={terminal} />
                    <RowValue title="Gate" value={gate} />
                    <RowValue title="Stand" value={stand} />
                    <RowValue title={""} value={""} />

                </div>
            </div>

            {/* Passenger Information */}
            <div style={{ marginBottom: Spacing.SCALE_24 }}>
                <Subtitle>Passenger Information</Subtitle>
                <hr />
                {Array.isFullArray(taskToView?.passengers) && taskToView?.passengers?.length > 0
                    ? <GroupedPax paxArray={taskToView?.passengers} notes={bookingNotes} arrOrDep={arrOrDep} />
                    : <div
                        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", rowGap: Spacing.SCALE_12, columnGap: Spacing.SCALE_48, marginTop: Spacing.SCALE_16 }}>
                        <RowValue title="Name" value={passenger} />
                        <RowValue title="Assistance" value={assistance} />
                        <RowValue title="Notes" value={handleNotesText(taskToView)} />
                        <RowValue title="SITA Notes" value={sitaNotes} />
                    </div>}
            </div>

            {/* Task Information */}
            <div>
                <Subtitle>Task Information</Subtitle>
                <hr />
                <div
                    style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", rowGap: Spacing.SCALE_12, columnGap: Spacing.SCALE_48, marginTop: Spacing.SCALE_16 }}>
                    <RowValue title="Pickup" value={taskToView?.pickUpLocation?.name ?? "N/A"} />
                    <RowValue title="Drop off" value={taskToView?.dropOffLocation?.name ?? "N/A"} />
                    <RowValue title="Start Task Time" value={taskStartTime} />
                    <RowValue title="Task Duration" value={taskDuration} />

                    {checkInTime && <RowValue title="Check-in time" value={checkInTime} />}

                </div>
            </div>
            {(taskToView.passengers === null || !taskToView.passengers) && <div>
                <PaxJourney bookingId={taskToView.originalBookingId || taskToView._id} type={arrOrDep} />
            </div>}
        </div>
    );
};

export default ViewJob;